import { render } from "./AutoCoverPlate.vue?vue&type=template&id=24562892"
import script from "./AutoCoverPlate.vue?vue&type=script&lang=js"
export * from "./AutoCoverPlate.vue?vue&type=script&lang=js"

import "./AutoCoverPlate.vue?vue&type=style&index=0&id=24562892&lang=scss"

import exportComponent from "D:\\myWork\\SAAS\\Group-Carwins-H5-1.0\\carwins-h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__